import WidgetAreaContainer from 'components/WidgetArea/WidgetAreaContainer'

export default {
  Container: WidgetAreaContainer,
}
